module.exports = __webpack_public_path__ + "img/robot-logo.863425a5.png";